import React, { useEffect, useState } from "react";
import styles from "./status-tab.module.css";
import getSaviorStatProgress from "../../../../functions/getSaviorStatProgress";
import Potential from "./potential";
import { v4 } from "uuid";
import { getSaviorStatRank } from "../../../../functions/getSaviorStatRanks";
import { JOURNEY_STATUS_TYPE, LOCALES, NORMAL_STATUS_TYPE, UI_TEXT } from "../../../../constants";
import { getUIText } from "../../../../translation";
import { loadData } from "../../../../functions/dataLoader";
import CONFIG from "../../../../config/modal_savior_status_config.json";

export default function StatusTab({ lang, savior, isTabActive }) {
    const [rank, setRank] = useState(getSaviorStatRank(savior));
    // const [config, setConfig] = useState(null);

    // useEffect(() => {
    //     loadData("modal_savior_status_config.json").then(setConfig);
    // }, []);

    useEffect(() => {
        setRank(getSaviorStatRank(savior));
    }, [savior]);

    const getStatValue = (type, value) => {
        if (type === "number") return value.toLocaleString("ko-KR");
        if (type === "percent") return `${parseInt(value * 100)}%`;
    };

    const getStatRankString = (statName) => {
        if (lang === LOCALES.KO) return `${rank.ranks[statName]}위`;
        else return `Rank ${rank.ranks[statName]}`;
    };

    const getJourneyStatus = () => {
        const obj = JSON.parse(JSON.stringify(savior.journey_base_stat));

        for (const resonance of savior.resonances) {
            if (resonance.journey_stat.type) {
                obj[resonance.journey_stat.type] += resonance.journey_stat.value;
            }
        }

        return obj;
    };

    const journeyStatus = getJourneyStatus();

    // if (!config) return;

    return (
        <div className={`${styles["status-tab"]} ${styles[isTabActive]}`}>
            <div className={styles["group"]}>
                <h3>
                    {getUIText(lang, "savior.modal.status.title")} (Lv.<span id="stat-max-level">{savior.rank === "SSR" ? 200 : 160}</span>)
                </h3>
                <div className={styles["stats"]}>
                    {CONFIG.STATUS.map((config) => {
                        return (
                            <div className={styles["stat-row"]} key={v4()}>
                                <div className={styles["stat-name"]}>{NORMAL_STATUS_TYPE[config.value][lang]}</div>
                                <div className={styles["stat-bar-container"]}>
                                    <div
                                        className={styles["stat-bar"]}
                                        style={{ width: `${getSaviorStatProgress(savior, config.value)}%` }}
                                    ></div>
                                </div>
                                <div className={styles["stat-value"]}>{getStatValue(config.type, rank.status[config.value])}</div>
                                <div className={styles["stat-rank"]}>{getStatRankString(config.value)}</div>
                            </div>
                        );
                    })}
                </div>
                <div className={styles["stat-grids"]}>
                    <div className={styles["stat-item"]}>
                        <span>{NORMAL_STATUS_TYPE["eff_rate"][lang]}</span>
                        <span>{parseInt(rank.status.eff_rate * 100)}%</span>
                    </div>
                    <div className={styles["stat-item"]}>
                        <span>{NORMAL_STATUS_TYPE["eff_resist"][lang]}</span>
                        <span>{parseInt(rank.status.eff_resist * 100)}%</span>
                    </div>
                    <div className={styles["stat-item"]}>
                        <span>{NORMAL_STATUS_TYPE["acc"][lang]}</span>
                        <span>{parseInt(rank.status.acc * 100)}%</span>
                    </div>
                </div>
            </div>
            <div className={styles["journey-wrapper"]}>
                <div className={styles["group"]}>
                    <h3>{getUIText(lang, "savior.modal.journeyStatus.title")}</h3>
                    <div className={`${styles["stat-grids"]} ${styles["journey"]}`}>
                        {CONFIG.JOURNEY_STATUS.map((config) => {
                            return (
                                <div className={styles["stat-item"]} key={v4()}>
                                    <span className={styles["stat-label"]}>{JOURNEY_STATUS_TYPE[config.value][lang]}</span>
                                    <span className={styles["stat-value"]}>{journeyStatus[config.value]}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className={styles["group"]}>
                    <h3>{getUIText(lang, "savior.modal.resonance.title")}</h3>
                    <div className={styles["potentials"]}>
                        {savior.resonances
                            .filter((e) => e.potential)
                            .map((resonance) => {
                                return <Potential lang={lang} resonance={resonance} key={v4()} />;
                            })}
                    </div>
                </div>
            </div>
        </div>
    );
}
